import { InfoOnMultipleLineCombinedProps } from './types';

const usePresenter = (props: InfoOnMultipleLineCombinedProps): InfoOnMultipleLineCombinedProps => {
  return props;
};

export default usePresenter;
